<template>
	<div class="fame-teacher" :class="{ 'fame-teacher--en': locale === 'en' }">
		<div class="title">
			{{ t("index.fameTeacher.title") }}
			<img src="../../../images/pc/circle.png" class="circle" alt="" />
		</div>
		<img src="../../../images/pc/union.png" class="guide" alt="" />
		<!-- 老师排行 -->
		<div class="box1">
			<div ref="rankingSectionRef" class="left">
				<div class="section-title">
					<img src="../../../images/pc/left3.png" class="pic" alt="" />
					{{ t("index.fameTeacher.title1") }}
					<img src="../../../images/pc/right3.png" class="pic" alt="" />
				</div>
				<div class="teacher-list">
					<article
						v-for="teacher in teacherRankingList"
						:key="teacher.id"
						class="teacher-card"
						role="button"
						tabindex="0"
						@click="handleTeacherClick(teacher)"
						@keydown.enter="handleTeacherClick(teacher)"
					>
						<span class="teacher-card__rank">{{ teacher.rank }}</span>
						<div class="teacher-card__avatar">
							<img
								v-if="teacher.avatar"
								:src="teacher.avatar"
								:alt="teacher.name"
								class="teacher-card__avatar-img"
							/>
						</div>
						<div class="teacher-card__info">
							<h3 class="teacher-card__name">{{ teacher.name }}</h3>
							<div class="teacher-card__tags">
								<span
									v-for="(tag, tagIndex) in teacher.tags"
									:key="`${tag}-${tagIndex}`"
									class="teacher-card__tag"
								>
									{{ tag }}
								</span>
							</div>
							<div class="teacher-card__rating">
								<img :src="start" alt="" aria-hidden="true" />
								<span
									>{{ teacher.rating }} ({{ teacher.consultCount
									}}{{ t("index.fameTeacher.consultUnit") }})</span
								>
							</div>
						</div>
						<img :src="more" class="teacher-card__arrow" alt="" aria-hidden="true" />
					</article>
				</div>
			</div>
			<div class="right">
				<div class="section-title">
					<img src="../../../images/pc/shine.png" class="pic2" alt="" />
					{{ t("index.fameTeacher.title2") }}
					<img src="../../../images/pc/shine.png" class="pic2" alt="" />
				</div>
				<div class="topic-grid">
					<article
						v-for="(topic, index) in topicList"
						:key="topic.id"
						class="topic-card"
						role="button"
						tabindex="0"
						@click="handleTopicClick(topic, index)"
						@keydown.enter="handleTopicClick(topic, index)"
					>
						<div class="topic-card__icon-wrap">
							<img :src="topic.icon" :alt="topic.title" class="topic-card__icon" />
						</div>
						<h3 class="topic-card__title">{{ topic.title }}</h3>
						<p class="topic-card__desc" :class="{ 'topic-card__desc--en': locale === 'en' }">
							{{ topic.desc }}
						</p>
						<div class="topic-card__link">
							<span>{{ t("index.fameTeacher.viewTeachers") }}</span>
							<img :src="guide" alt="" aria-hidden="true" />
						</div>
					</article>
					<!-- <div class="topic-illustration">
						<img :src="fameImage" :alt="t('index.fameTeacher.title2')" />
					</div> -->
				</div>
			</div>
		</div>
		<!-- 查看更多 -->
		<div class="box-more">
			<button class="box-more__action" type="button" @click="handleViewMoreTeachers">
				{{ t("index.fameTeacher.viewMore") }}
				<img src="../../../images/pc/guide.png" class="guide2" alt="" />
			</button>
			<div class="box-more__stats">
				<div v-for="item in trustStats" :key="item.id" class="box-more__stat-item">
					<div class="box-more__stat-value">{{ item.value }}</div>
					<div class="box-more__stat-label">{{ item.label }}</div>
				</div>
			</div>
		</div>
		<!-- 入驻 -->
		<div class="box-join">
			<div class="box-join__accent" aria-hidden="true" />
			<div class="box-join__content">
				<img :src="joinIcon" class="box-join__icon" alt="" aria-hidden="true" />
				<div class="box-join__text">
					<h3 class="box-join__title">{{ t("index.fameTeacher.join.title") }}</h3>
					<p class="box-join__desc">{{ t("index.fameTeacher.join.desc") }}</p>
				</div>
			</div>
			<button class="box-join__button" type="button" @click="handleJoinMentor">
				{{ t("index.fameTeacher.join.button") }}
			</button>
		</div>
	</div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useI18n } from "~/composables/useI18n";
import {
	formatMentorTags,
	useHomepageTracking,
	useSectionView,
} from "@variants/index/composables/useHomepageTracking";
import more from "../../../images/pc/more.png";
import start from "../../../images/pc/start.png";
import fame1 from "../../../images/pc/fame1.png";
import fame2 from "../../../images/pc/fame2.png";
import fame3 from "../../../images/pc/fame3.png";
import fame4 from "../../../images/pc/fame4.png";
import fameImage from "../../../images/pc/fame-image.png";
import guide from "../../../images/pc/guide.png";
import joinIcon from "../../../images/pc/fame-ruzhu.png";
import { getHomeFameTeacher } from "~/api/api";

const { t, locale } = useI18n();
const { track } = useHomepageTracking("pc");
const rankingSectionRef = ref(null);

useSectionView(rankingSectionRef, {
	track,
	sectionId: "mentor_ranking",
});

const RANKING_SIZE = 5;

const { data: fameTeacherData } = await useLazyAsyncData(
	() => `home-fame-teacher-pc-${locale.value}`,
	async () => {
		const res = await getHomeFameTeacher({
			page: 1,
			v: 2,
			size: 10,
		});
		return (res?.data?.list || []).slice(0, RANKING_SIZE).map(formatFameTeacher);
	},
	{
		default: () => [],
		server: true,
		watch: [locale],
	}
);

const teacherRankingList = computed(() => {
	return (fameTeacherData.value || []).map((teacher, index) => ({
		...teacher,
		rank: index + 1,
		name: pickLocalizedName(teacher),
		tags: pickLocalizedTags(teacher),
	}));
});

function formatFameTeacher(teacher) {
	return {
		id: teacher?.answer_id || teacher?.id,
		answerId: teacher?.answer_id || "",
		nickname: teacher?.nickname || "",
		nicknameEn: teacher?.nickname_en || teacher?.nickname || "",
		avatar: teacher?.avatar || "",
		tagsZh: normalizeTagList(teacher?.tags),
		tagsEn: normalizeTagList(teacher?.tags_en),
		academicSector: Array.isArray(teacher?.academic_sector)
			? teacher.academic_sector.filter(Boolean).slice(0, 2)
			: [],
		rating: formatScore(teacher?.score),
		consultCount: Number(teacher?.answers) || 0,
		link: teacher?.answer_id ? `/seer/teacher-detail/${teacher.answer_id}` : "/seer/master-fortune",
	};
}

function normalizeTagList(source) {
	if (typeof source !== "string") return [];
	return source
		.split(",")
		.map(item => item.trim())
		.filter(Boolean)
		.slice(0, 2);
}

function pickLocalizedName(teacher) {
	const isEn = locale?.value === "en";
	return (
		(isEn ? teacher.nicknameEn : teacher.nickname) ||
		teacher.nickname ||
		t("index.teacherConsultation.defaultName")
	);
}

function pickLocalizedTags(teacher) {
	const isEn = locale?.value === "en";
	const localizedTags = isEn ? teacher.tagsEn : teacher.tagsZh;
	if (localizedTags.length) return localizedTags;
	return teacher.academicSector.length ? teacher.academicSector : [];
}

function formatScore(value) {
	const score = Number(value);
	if (!score) return "5.0";
	return Math.min(score, 5).toFixed(1);
}

function handleTeacherClick(teacher) {
	track("mentor_ranking_click", {
		mentor_id: String(teacher.id || teacher.answerId || ""),
		mentor_name: teacher.name,
		rank: teacher.rank,
		topic_tags: formatMentorTags(teacher.tags),
	});
	navigateTo(teacher.link || "/seer/master-fortune");
}

function handleViewMoreTeachers() {
	track("more_mentor_click", {
		section_id: "mentor_ranking",
	});
	navigateTo("/seer/master-fortune");
}

function handleJoinMentor() {
	track("mentor_apply_click", {
		element_id: "apply_mentor_banner",
	});
	navigateTo("/seer/mentor-join");
}

function handleTopicClick(topic, index) {
	track("mentor_topic_click", {
		topic_id: topic.key,
		topic_name: topic.title,
		position: index + 1,
	});
	navigateTo("/seer/master-fortune");
}

const trustStats = computed(() => [
	{
		id: "masters",
		value: t("index.fameTeacher.stats.masters.value"),
		label: t("index.fameTeacher.stats.masters.label"),
	},
	{
		id: "privacy",
		value: t("index.fameTeacher.stats.privacy.value"),
		label: t("index.fameTeacher.stats.privacy.label"),
	},
	{
		id: "satisfaction",
		value: t("index.fameTeacher.stats.satisfaction.value"),
		label: t("index.fameTeacher.stats.satisfaction.label"),
	},
	{
		id: "users",
		value: t("index.fameTeacher.stats.users.value"),
		label: t("index.fameTeacher.stats.users.label"),
	},
]);

const topicList = computed(() => [
	{
		id: 1,
		key: "love",
		icon: fame1,
		title: t("index.fameTeacher.topics.love.title"),
		desc: t("index.fameTeacher.topics.love.desc"),
	},
	{
		id: 2,
		key: "career",
		icon: fame2,
		title: t("index.fameTeacher.topics.career.title"),
		desc: t("index.fameTeacher.topics.career.desc"),
	},
	{
		id: 3,
		key: "health",
		icon: fame3,
		title: t("index.fameTeacher.topics.health.title"),
		desc: t("index.fameTeacher.topics.health.desc"),
	},
	{
		id: 4,
		key: "decision",
		icon: fame4,
		title: t("index.fameTeacher.topics.decision.title"),
		desc: t("index.fameTeacher.topics.decision.desc"),
	},
]);
</script>

<style lang="scss" scoped>
.fame-teacher {
	width: 100%;
	margin-top: 120px;

	.title {
		width: 100%;
		position: relative;
		font-size: 32px;
		color: #333333;
		font-weight: bold;
		text-align: center;
		z-index: 5;

		.circle {
			position: absolute;
			width: 75px;
			height: 67px;
			top: 0;
			left: 160px;
			z-index: -1;
		}
	}

	.guide {
		display: block;
		width: 44px;
		height: 97px;
		margin: 30px auto 80px;
	}

	.box1 {
		display: flex;
		gap: 40px;
		align-items: flex-start;
	}

	.section-title {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 16px;
		margin-bottom: 24px;
		font-size: 24px;
		line-height: 36px;
		color: #333;
		font-weight: bold;

		.pic {
			width: 15px;
			height: 26px;
			flex-shrink: 0;
		}

		.pic2 {
			width: 18px;
			height: 18px;
			flex-shrink: 0;
		}
	}

	.left {
		flex: 0 0 37%;
		min-width: 0;
	}

	.teacher-list {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.teacher-card {
		display: flex;
		align-items: center;
		gap: 12px;
		padding: 14px 16px;
		background: #ffffff;
		border: 1px solid #efefef;
		border-radius: 12px;
		cursor: pointer;

		&__rank {
			flex-shrink: 0;
			width: 28px;
			font-size: 32px;
			line-height: 1;
			color: #333333;
			font-weight: bold;
			text-align: center;
		}

		&__avatar {
			flex-shrink: 0;
			width: 98px;
			height: 98px;
			border-radius: 50%;
			background: #efefef;
			border: 1px solid #eeeeee;
			overflow: hidden;
		}

		&__avatar-img {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		&__info {
			flex: 1;
			min-width: 0;
		}

		&__name {
			margin: 0;
			font-size: 18px;
			line-height: 24px;
			color: #333;
			font-weight: 500;
		}

		&__tags {
			display: flex;
			flex-wrap: wrap;
			gap: 6px;
			margin: 10px 0;
		}

		&__tag {
			display: inline-flex;
			align-items: center;
			height: 24px;
			padding: 0 10px;
			background: #f7f7f7;
			border-radius: 999px;
			font-size: 16px;
			line-height: 18px;
			color: #666666;
		}

		&__rating {
			display: flex;
			align-items: center;
			gap: 4px;
			margin-top: 6px;
			font-size: 14px;
			line-height: 18px;
			color: #666666;

			img {
				width: 14px;
				height: 14px;
				flex-shrink: 0;
			}
		}

		&__arrow {
			flex-shrink: 0;
			width: 24px;
			height: 24px;
		}
	}

	.right {
		flex: 1;
		min-width: 0;
	}

	.topic-grid {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: 40px;
	}

	.topic-card {
		display: flex;
		flex-direction: column;
		padding: 50px 16px 30px;
		background: #ffffff;
		border-radius: 12px;
		cursor: pointer;

		&__icon-wrap {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 66px;
			height: 66px;
			margin: 0 auto 12px;
		}

		&__icon {
			width: 66px;
			height: 66px;
			object-fit: contain;
		}

		&__title {
			margin: 0;
			font-size: 24px;
			line-height: 26px;
			color: #333333;
			font-weight: normal;
			text-align: center;
		}

		&__desc {
			flex: 1;
			margin: 15px 0;
			font-size: 18px;
			line-height: 1.2;
			color: #666666;
			text-align: center;
			padding: 0 45px;

			&--en {
				padding: 0;
			}
		}

		&__link {
			display: inline-flex;
			justify-content: center;
			align-items: center;
			gap: 6px;
			margin-top: 14px;
			font-size: 20px;
			line-height: 20px;
			color: #333333;
			cursor: pointer;

			img {
				width: 26px;
				height: 26px;
			}
		}

		&:nth-child(4) {
			grid-column: 1;
			grid-row: 2;
		}
	}

	&--en {
		.topic-card__title {
			font-size: 20px;
			line-height: 22px;
		}

		.box-more__action {
			font-size: 22px !important;
		}

		.box-more__stat-label {
			font-size: 13px !important;
		}
	}

	.topic-illustration {
		grid-column: 2 / 4;
		grid-row: 2;
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: 200px;
		padding: 16px;

		img {
			display: block;
			max-width: 100%;
			max-height: 220px;
			object-fit: contain;
		}
	}

	.box-more {
		display: flex;
		gap: 50px;
		margin-top: 24px;
		align-items: stretch;

		&__action {
			flex: 0 0 445px;
			display: inline-flex;
			justify-content: center;
			align-items: center;
			gap: 8px;
			padding: 0 24px;
			background: #ffffff;
			border: 1px solid #efefef;
			border-radius: 12px;
			font-size: 24px;
			line-height: 28px;
			color: #333333;
			cursor: pointer;

			.guide2 {
				width: 26px;
				height: 26px;
			}
		}

		&__arrow {
			font-family: inherit;
			line-height: 1;
		}

		&__stats {
			flex: 1;
			display: flex;
			justify-content: space-around;
			align-items: center;
			padding: 20px;
			background: #fffcf7;
			border-radius: 12px;
			min-height: 88px;
			border: 1px solid #fff2e9;
		}

		&__stat-item {
			flex: 1;
			text-align: center;
		}

		&__stat-value {
			font-size: 18px;
			line-height: 28px;
			color: #333;
		}

		&__stat-label {
			margin-top: 6px;
			font-size: 16px;
			line-height: 20px;
			color: rgba(51, 51, 51, 0.6);
		}
	}

	.box-join {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 24px;
		margin: 40px 0 0;
		padding: 24px 32px 24px 0;
		background: #ffffff;
		border: 1px solid #efefef;
		border-radius: 12px;
		box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
		overflow: hidden;

		&__accent {
			position: absolute;
			top: 0;
			left: 0;
			width: 15px;
			height: 100%;
			background: #f5a623;
			border-radius: 12px;
		}

		&__content {
			display: flex;
			align-items: center;
			gap: 16px;
			padding-left: 32px;
			min-width: 0;
		}

		&__icon {
			flex-shrink: 0;
			width: 90px;
			height: 90px;
			padding: 10px;
			border-radius: 50%;
			box-sizing: border-box;
			object-fit: contain;
		}

		&__text {
			min-width: 0;
		}

		&__title {
			margin: 0;
			font-size: 24px;
			line-height: 30px;
			color: #333333;
			font-weight: 500;
		}

		&__desc {
			margin: 4px 0 0;
			font-size: 18px;
			line-height: 24px;
			color: #333333;
			margin-top: 10px;
		}

		&__button {
			flex-shrink: 0;
			padding: 15px 20px;
			border: 0;
			border-radius: 8px;
			background: #f5a623;
			font-size: 20px;
			line-height: 24px;
			color: #ffffff;
			cursor: pointer;
			text-align: center;

			&:hover {
				opacity: 0.7;
			}
		}
	}
}
</style>
